import { handleResponse } from './helper';
import config from '../config';

const searchPatient = async (params) => {
  const requestOptions = {
    method: 'GET'
  };
  const url = new URL(`${config.apiUrl}/patients/${params.documentType}/${params.documentNumber}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const patientTest = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      country_code: params.countryCode,
    }
  };
  const url = new URL(`${config.apiUrl}/exams/${params.documentType}/${params.documentNumber}/surveys`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const getDriversLicense = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      country_code: params.countryCode,
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/driverLicenses`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const getEducationLevel = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      country_code: params.countryCode,
    }
  };
  const url = new URL(`${config.apiUrl}/general/educationLevel`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const validationService = {
  searchPatient,
  patientTest,
  getDriversLicense,
  getEducationLevel
};